import { render, staticRenderFns } from "./UdefButton.vue?vue&type=template&id=e3121f32&scoped=true&"
import script from "./UdefButton.vue?vue&type=script&lang=js&"
export * from "./UdefButton.vue?vue&type=script&lang=js&"
import style0 from "./UdefButton.vue?vue&type=style&index=0&id=e3121f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3121f32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
